const FormETIcon = () => {
  return (
    <svg
      width="128"
      height="168"
      viewBox="0 0 128 168"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8233 167.378C10.8485 166.543 8.69104 165.978 6.92937 164.816C2.67094 162.002 0.465602 157.887 0.465602 152.737C0.465602 106.943 0.465602 61.1495 0.465602 15.3579C0.445871 13.4275 0.81117 11.5126 1.54015 9.72501C2.26912 7.93745 3.34714 6.31316 4.71118 4.94709C6.07522 3.58103 7.69792 2.5006 9.48439 1.76897C11.2709 1.03734 13.1853 0.669223 15.1157 0.686091C37.7345 0.662892 60.3534 0.654167 82.9723 0.659966C83.782 0.640043 84.5871 0.789144 85.336 1.09771C86.085 1.40627 86.7614 1.86751 87.3221 2.45207C100.05 15.2114 112.787 27.9476 125.535 40.6606C126.158 41.26 126.649 41.9836 126.975 42.7846C127.301 43.5856 127.455 44.4462 127.427 45.3105C127.395 80.8482 127.388 116.386 127.405 151.924C127.405 159.862 123.203 165.199 115.452 167.148C115.303 167.209 115.164 167.291 115.039 167.392L12.8233 167.378ZM117.653 49.4993H115.691C108.258 49.4993 100.828 49.4993 93.3943 49.4993C84.9819 49.4993 78.6051 43.0791 78.6051 34.6492C78.6051 27.1632 78.6051 19.6772 78.6051 12.1869V10.447H16.1596C12.0795 10.447 10.2135 12.3217 10.2135 16.4192V151.697C10.2135 155.773 12.0926 157.639 16.1944 157.639H111.581C115.861 157.639 117.671 155.812 117.671 151.48V49.5298L117.653 49.4993ZM88.3399 17.5719C88.3399 23.2832 88.3399 28.7378 88.3399 34.1968C88.3399 37.7332 90.3452 39.7297 93.8859 39.7428C98.9809 39.7428 104.075 39.7428 109.167 39.7428C109.576 39.7224 109.984 39.6804 110.389 39.6166C103.064 32.2786 95.8259 25.0405 88.3573 17.5763L88.3399 17.5719Z"
        fill="black"
      />
      <path
        d="M48.0325 92.9643H37.2651V101.833H49.7789V104.524H34V79.5239H49.5967V82.2303H37.2651V90.2732H48.0325V92.9643Z"
        fill="black"
      />
      <path
        d="M70.6291 82.2303H62.6409V104.524H59.3758V82.2303H51.418V79.5239H70.6291V82.2303Z"
        fill="black"
      />
      <path
        d="M93 104.524H89.7197V92.9643H77.1907V104.524H73.9256V79.5239H77.1907V90.2732H89.7197V79.5239H93V104.524Z"
        fill="black"
      />
    </svg>
  );
};

export default FormETIcon;
